import { RenameRegisterDialog } from "./rename-register-dialog"
import { RegisterMetadataMenuItem } from "../register-actions/register-metadata-menu-item"

export function RenameRegisterMenuItem() {
    return (
        <RegisterMetadataMenuItem
            icon="eva:edit-fill"
            label="Rename"
            dataCy="register-row-menu-rename"
            DialogComponent={RenameRegisterDialog}
            errorMessage="Failed to rename asset register"
            getUpdateValues={getUpdateValues}
        />
    )

    function getUpdateValues(updated) {
        return { name: updated.name }
    }
}
